var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "header" } },
    [
      _c("div", { attrs: { id: "member_logo" }, on: { click: _vm.toTop } }, [
        _c("img", {
          attrs: {
            src:
              "https://triple-crown.co.jp/wp-content/themes/triplecrown_v2/images/logo.png",
            width: "200",
            alt: ""
          }
        })
      ]),
      _vm._v(" "),
      _vm.isUseCancel
        ? _c("p", { staticClass: "form_category" }, [
            _vm._v("\n    " + _vm._s(_vm.isPayment) + "\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isLogin
        ? _c(
            "el-button",
            {
              staticClass: "logout_btn",
              attrs: { type: "primary", plain: "" },
              on: { click: _vm.logout }
            },
            [_vm._v("ログアウト")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isUseCancel
        ? _c(
            "el-button",
            {
              staticClass: "cancel_btn",
              attrs: { type: "warning" },
              on: { click: _vm.cancel }
            },
            [_vm._v("申込みのキャンセル")]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isUseCancel
        ? _c("p", { staticClass: "store_name" }, [
            _vm._v(_vm._s(_vm.storeName))
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }